{
    "Page_Title": "Beheerdersacties",
    "Action_Label_MC": "Bellen",
    "Action_Label_MCC": "Consultatiegesprek",
    "Action_Label_MDT": "DTMF-toon kiezen",
    "Action_Label_CC": "Clear Call (via oproepbeheer)",
    "Action_Label_CCCM": "Clear Call (Via Call-model)",
    "Action_Label_CX": "Duidelijke verbinding",
    "Action_Label_AC": "Beantwoord oproep",
    "Action_Label_HD": "Gesprek in de wacht zetten",
    "Action_Label_PC": "Parkeeroproep",
    "Action_Label_RC": "Oproep ophalen",
    "Action_Label_ATC": "Alternatieve oproep",
    "Action_Label_PUC": "Ophaalgesprek",
    "Action_Label_TO": "Eén stap overzetten",
    "Action_Label_TR": "Overdracht voltooid",
    "Action_Label_DF": "Oproep omleiden\/afbuigen",
    "Action_Label_MONC": "Monitorverbinding",
    "Action_Label_REC": "Oproep opnemen",
    "Action_Label_CBMSG": "Registreer terugbellen",
    "Action_Label_CO": "Conferentie deelnemen",
    "Action_Label_MES": "Monitorstart",
    "Action_Label_MEP": "Monitor Stop",
    "Action_Label_SDND": "DNS-status instellen",
    "Action_Label_SACD": "ACD-status instellen",
    "Action_Label_SFWD": "Voorwaartse status instellen",
    "Action_Label_SACC": "Accountcode instellen",
    "Action_Label_SPWD": "Entiteitswachtwoord instellen",
    "Action_Label_QDND": "Vraag DND-status op",
    "Action_Label_QACD": "ACD-status opvragen",
    "Action_Label_QFWD": "Query doorstuurstatus",
    "Action_Label_SPC": "Momentopname-oproep",
    "Action_Label_SPD": "Snapshot-apparaat",
    "AcdOption_SignIn": "Aanmelden",
    "AcdOption_SignOut": "Afmelden",
    "AcdOption_Available": "Beschikbaar",
    "AcdOption_NotAvailable": "Niet beschikbaar",
    "AcdOption_AlertingAcd": "Waarschuwing (ACD)",
    "AcdOption_AlertingNonAcd": "Waarschuwing (niet-ACD)",
    "AcdOption_BusyAcd": "Druk (ACD)",
    "AcdOption_BusyNonAcd": "Bezet (Niet ACD)",
    "AcdOption_BusySupervisor": "Druk (Supervisor)",
    "AcdOption_AcdDnd": "ACD-DND",
    "AcdOption_WrapUp": "Afronden",
    "ForwardOption_None": "Geen",
    "ForwardOption_Immediate": "Onmiddellijk",
    "ForwardOption_OnBusy": "Bezet",
    "ForwardOption_NoAnswer": "Geen antwoord",
    "ForwardOption_OnDnd": "Op DND",
    "ForwardOption_OnOos": "Op OOS",
    "Field_Label_DeviceMain": "Apparaat",
    "Field_Label_Destination": "Bestemming",
    "Field_Label_CallIDMain": "Actieve CallID",
    "Field_Label_DestinationAutoPrefix": "Automatische voorvoegselbestemming?",
    "Field_Label_CallIDHeld": "Andere CallID",
    "Field_Label_DTMFTones": "DTMF-tonen",
    "Field_Label_ParkLocation": "Parklocatie",
    "Field_Label_OtherCallID": "Andere CallID",
    "Field_Label_DeviceToPickupAt": "Apparaat om op te halen",
    "Field_Label_CallParked": "Oproep geparkeerd",
    "Field_Label_MonitorType": "Monitortype",
    "Field_Label_Password": "Wachtwoord",
    "Field_Label_UseSecurePassword": "Veilig wachtwoord gebruiken?",
    "Field_Label_MonitorCrossRefID": "Monitor Kruis Ref ID",
    "Field_Label_IsDND": "Niet storen aan\/uit",
    "Field_Label_AgentID": "Agent-ID",
    "Field_Label_ACDGroup": "ACDGroup",
    "Field_Label_ACDStateReasonTextID": "ACDStateReasonTextID",
    "Field_Label_ACDStatus": "ACD-status",
    "Field_Label_ForwardMode": "Voorwaartse status",
    "Field_Label_AccountCode": "Rekeningcode",
    "Field_Label_PasswordOld": "Oud wachtwoord",
    "Field_Label_PasswordNew": "Nieuw wachtwoord",
    "Field_Label_TelephonyServer": "Telefonieserver",
    "Field_Label_Partition": "Partitie",
    "Field_Label_CME": "CME",
    "Action_Button_Label_Execute": "Uitvoeren",
    "Action_Button_Label_Reset": "Reset",
    "NAME": "AdminActionsLanguage",
    "Action_Label": "Actie",
    "Action_Label_GUC": "Bekijk het gebruikersconformiteitsbeleid",
    "Action_Label_AAP": "Pas het Akixi-opnamebeleid toe.",
    "Action_Label_QPS": "Aanwezigheidsstatus opvragen",
    "Action_Label_DUP": "Beleid voor het verwijderen van gebruikers",
    "Action_Label_GT": "Huurder zoeken",
    "Action_Label_DT": "Huurder verwijderen",
    "Action_Label_GU": "Gebruikers werven",
    "Action_Label_GVA": "Download spraakapps",
    "Field_Label_SilentMonitor": "Stille monitor",
    "Field_Label_ForcedIntrude": "Geforceerde indringing",
    "Field_Label_Policies": "Beleid"
}